module.exports = __webpack_public_path__ + "static/img/sys-maintance@2x9e006bd.png";